import { render, staticRenderFns } from "./authorInfo.vue?vue&type=template&id=678d0fb7&scoped=true&"
import script from "./authorInfo.vue?vue&type=script&lang=js&"
export * from "./authorInfo.vue?vue&type=script&lang=js&"
import style0 from "./authorInfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./authorInfo.vue?vue&type=style&index=1&id=678d0fb7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678d0fb7",
  null
  
)

export default component.exports